var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4971_26990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4971_26990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3126 9.99992L11.8959 12.4166C11.7292 12.5833 11.6494 12.7777 11.6563 12.9999C11.6633 13.2221 11.7501 13.4166 11.9167 13.5833C12.0834 13.736 12.2779 13.8159 12.5001 13.8228C12.7223 13.8298 12.9167 13.7499 13.0834 13.5833L16.9167 9.74992C17.0834 9.58325 17.1667 9.38881 17.1667 9.16659C17.1667 8.94436 17.0834 8.74992 16.9167 8.58325L13.0834 4.74992C12.9306 4.59714 12.7397 4.52075 12.5105 4.52075C12.2813 4.52075 12.0834 4.59714 11.9167 4.74992C11.7501 4.91659 11.6667 5.1145 11.6667 5.34367C11.6667 5.57284 11.7501 5.77075 11.9167 5.93742L14.3126 8.33325H6.66675C5.51397 8.33325 4.53133 8.7395 3.71883 9.552C2.90633 10.3645 2.50008 11.3471 2.50008 12.4999V14.9999C2.50008 15.236 2.57994 15.4339 2.73967 15.5937C2.89939 15.7534 3.0973 15.8333 3.33341 15.8333C3.56953 15.8333 3.76744 15.7534 3.92717 15.5937C4.08689 15.4339 4.16675 15.236 4.16675 14.9999V12.4999C4.16675 11.8055 4.4098 11.2152 4.89591 10.7291C5.38203 10.243 5.9723 9.99992 6.66675 9.99992H14.3126Z",
    fill: "#7D889F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.98968f2c258639fb75815a834f302d9b.svg";
export { ForwardRef as ReactComponent };